import React from 'react';

interface Props {
  data: any;
  shipper: any;
}

function PackageDetails({ data, shipper }: Props) {
  return (
    <div className='ubbe-card h-100'>
      <div className='ubbe-card-header'>
        <h5 className='ps-3 mb-0 GlobalBoxHead'>Package Details</h5>
      </div>
      <div className='card-body pt-2 p-4 h-auto'>
        <div className='row'>
          <div className='col-md-6'>
            <span className='global-text-16'>Vendor Name</span>
          </div>
          <div className='col-md-6 boldglobaltext text-break'>
            {data?.vendor_name ? data?.vendor_name : 'N/A'}
          </div>
        </div>
        <div className='row mt-2'>
          <div className='col-md-6'>
            <span className='global-text-16'>Quantity</span>
          </div>
          <div className='col-md-6 boldglobaltext text-break'>
            {data?.quantity ? data?.quantity : 'N/A'}
          </div>
        </div>
        <div className='row mt-2'>
          <div className='col-md-6'>
            <span className='global-text-16'>Description</span>
          </div>
          <div className='col-md-6 boldglobaltext text-break'>
            {data?.description ? data?.description : 'N/A'}
          </div>
        </div>
        <div className='row mt-2'>
          <div className='col-md-6'>
            <span className='global-text-16'>Length</span>
          </div>
          <div className='col-md-6 boldglobaltext text-break'>
            {data?.length ? data?.length : 'N/A'}
          </div>
        </div>
        <div className='row mt-2'>
          <div className='col-md-6'>
            <span className='global-text-16'>Width</span>
          </div>
          <div className='col-md-6 boldglobaltext text-break'>
            {data?.width ? data?.width : 'N/A'}
          </div>
        </div>
        <div className='row mt-2'>
          <div className='col-md-6'>
            <span className='global-text-16'>Height</span>
          </div>
          <div className='col-md-6 boldglobaltext text-break'>
            {data?.height ? data?.height : 'N/A'}
          </div>
        </div>
        <div className='row mt-2'>
          <div className='col-md-6'>
            <span className='global-text-16'>Weight lbs</span>
          </div>
          <div className='col-md-6 boldglobaltext text-break'>
            {data?.weight_lbs ? data?.weight_lbs : 'N/A'}
          </div>
        </div>
        <div className='row mt-2'>
          <div className='col-md-6'>
            <span className='global-text-16'>Unit of Measure Code</span>
          </div>
          <div className='col-md-6 boldglobaltext text-break'>
            {data?.unit_of_measure_code ? data?.unit_of_measure_code : 'N/A'}
          </div>
        </div>
        <div className='row mt-2'>
          <div className='col-md-6'>
            <span className='global-text-16'>Cubage</span>
          </div>
          <div className='col-md-6 boldglobaltext text-break'>
            {data?.cubage ? data?.cubage : 'N/A'}
          </div>
        </div>
        <div className='row mt-2'>
          <div className='col-md-6'>
            <span className='global-text-16'>Dangerous Codes Check</span>
          </div>
          <div className='col-md-6 boldglobaltext text-break'>
            {data?.dangerous_goods_check ? data?.dangerous_goods_check : 'N/A'}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PackageDetails;
